import { useMemo } from "react";
import { TaskListCapabilities } from "../taskListCapabilities";
import {
    buildOrganizationPageTaskViews,
    createWorkspacePageTaskViewsBuilder,
    useBuiltInTaskViews,
} from "./BuiltInTaskViews";

/** The Tasks page's built-in views for its capabilities; they count as loading until the client views are known. */
export function useTaskListBuiltInViews(
    capabilities: TaskListCapabilities,
): ReturnType<typeof useBuiltInTaskViews> {
    const { hasClientTaskViews, isLoadingClientTaskViews } = capabilities;
    const buildWorkspacePageTaskViews = useMemo(
        () => createWorkspacePageTaskViewsBuilder({ hasClientTaskViews }),
        [hasClientTaskViews],
    );
    const { builtInViews, isLoadingBuiltInViews } = useBuiltInTaskViews({
        defaultStatuses: capabilities.defaultStatuses,
        buildViews: capabilities.isCrossWorkspace
            ? buildOrganizationPageTaskViews
            : buildWorkspacePageTaskViews,
    });
    const isLoading = isLoadingBuiltInViews || isLoadingClientTaskViews;

    return useMemo(
        () => ({ builtInViews, isLoadingBuiltInViews: isLoading }),
        [builtInViews, isLoading],
    );
}
